import { render, staticRenderFns } from "./todos_toggle.vue.js?vue&type=template&id=c593c37c&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./todos_toggle.vue?vue&type=template&id=c593c37c&vue3"
import script from "./todos_toggle.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./todos_toggle.vue?vue&type=script&lang=js&vue3"
export * from "./todos_toggle.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./todos_toggle.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports